import constants from "config/constant";
import ls from "util/secureStorage";
import { get } from "./axiosLib";
import { logger } from "./logger";

export const calculateAge = (birthDate) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const birthYear = new Date(birthDate).getFullYear();
  const birthMonth = new Date(birthDate).getMonth();
  const birthDay = new Date(birthDate).getDate();
  let calculatedAge = currentYear - birthYear;

  if (currentMonth < birthMonth - 1) {
    calculatedAge--;
  }
  if (birthMonth - 1 === currentMonth && currentDay < birthDay) {
    calculatedAge--;
  }
  return calculatedAge;
};

export const secondsToDhms = (secs) => {
  const seconds = Number(secs);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
  var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
  var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
  let dhms = dDisplay + hDisplay + mDisplay + sDisplay;
  dhms = String(dhms).trim();
  if (dhms.endsWith(",")) dhms = String(dhms).slice(0, dhms.length - 1);
  return dhms;
};

// MathRound(3.256, 2) => gives 3.25 instead of 3.26
export const MathRound = (_num, nrdecimals) => {
  const num = Number(_num);
  let n = Number(num.toFixed(nrdecimals));
  return n > num
    ? toPrecision(n - 1 / Math.pow(10, nrdecimals), nrdecimals)
    : n;
};

export const summarizeTimeNarration = (narration, index = 1) => {
  const cNarate = String(narration).split(", ");
  let text = ``;
  Array(index + 1)
    .fill(0)
    .forEach((_, i) => {
      text += ` ${cNarate[i]}` || "";
      if (i >= 0 && i < index) text += ",";
    });
  return text;
};

export function getCookie(name) {
  function escape(s) {
    // eslint-disable-next-line
    return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, "\\$1");
  }
  // eslint-disable-next-line
  var match = document.cookie.match(
    RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)")
  );
  return match ? match[1] : null;
}

// const FLEXI_TAKERS_FEE = 0.008;
const FLEXI_TAKERS_FEE = 0;
export const deduction = (originalVolume) =>
  Number((Math.abs(originalVolume) * FLEXI_TAKERS_FEE).toFixed(8));

export const volume = (originalVolume) =>
  Number((Math.abs(originalVolume) - deduction(originalVolume)).toFixed(8));

export const floatString = (n) =>
  (n && (Number.isInteger(n) ? n.toFixed(1) : n.toString())) ?? "";

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const toQueryString = (params) =>
  Object.keys(params)
    .map((key) => {
      if (params[key]) return `${key}=${params[key]}`;
      return null;
    })
    .filter(Boolean) // filter out null or undefined values
    .join("&");

/**
 * Get exchange rate for a ticker
 * @param ticker
 * @param type
 * @returns {Promise<*>}
 */
export const getExchangeRate = async (ticker, type = "all") => {
  const token = localStorage.getItem("tokenset");
  const headers = {
    authorization: `${token}`,
    "Content-Type": "application/json",
  };
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/dashboard/exchangeRate?ticker=${ticker}`;
  const rateReq = await get(endpoint, headers);
  if (rateReq.status !== 200) {
    return Promise.reject("Rate not available");
  }

  const data = rateReq.data.data.exchangeRate.data.exchangeRate;
  logger("RESULT", data);
  return type === "all" ? data : data[type];
};

export const getChartData = async (
  coin,
  baseFiat = "usd",
  days = "30",
  hours = "24",
  interval = "daily"
) => {
  try {
    const token = localStorage.getItem("tokenset");
    const auth = ls.get(constants.AUTH_TOKEN_KEY);

    console.log("AUTH FROM CHART DATA", auth);
    const headers = {
      authorization: `${token}`,
      "Content-Type": "application/json",
    };

    const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/market/charts/prices?base=usd&coin=${coin}&days=${days}&hours=${hours}&interval=${interval}`;
    const chartReq = await get(endpoint, headers);

    const data = chartReq.data.data.marketChart.prices;
    const dates = [];
    const prices = [];

    data.forEach((item) => {
      dates.push(new Date(item[0]).toLocaleDateString());
      prices.push(item[1]);
    });

    return Promise.resolve({ dates, prices });
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getChartDataMonths = async (coin, baseFiat = "usd", days = 30) => {
  try {
    const token = localStorage.getItem("tokenset");
    const headers = {
      authorization: `${token}`,
      "Content-Type": "application/json",
    };

    const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/market/charts/prices?base=${baseFiat}&coin=${coin}&days=${days}&interval=monthly`;
    const chartReq = await get(endpoint, headers);

    const data = chartReq.data.data.marketChart.prices;
    const dates = [];
    const prices = [];

    data.forEach((item) => {
      dates.push(new Date(item[0]).toLocaleDateString());
      prices.push(item[1]);
    });

    return Promise.resolve({ dates, prices });
  } catch (err) {
    return Promise.reject(err);
  }
};

// Check if a string is a positive number
export const isNumeric = (value) => {
  return !Number.isNaN(Number(value));
};

export const isEmpty = (value) => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const randomSequentialId = () => {
  const uid = new Date().getTime().toString(36);
  return uid;
};

export const getParameterByName = (name, url = window.location.href) => {
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const wait = (val, timeout) =>
  new Promise((res) => {
    setTimeout(() => {
      res(val);
    }, timeout);
  });

export const lessThanSomeHoursAgo = (date, hoursAgo) => {
  const givenDate = date ? new Date(date) : new Date();
  const workingDate = new Date();
  workingDate.setHours(workingDate.getHours() - hoursAgo);
  const timeDifference = workingDate.getTime() - givenDate.getTime();
  return timeDifference < 0;
};

export const lessThanSomeMinutesAgo = (date, duration) => {
  const givenDate = date ? new Date(date) : new Date();
  const workingDate = new Date();
  workingDate.setMinutes(workingDate.getMinutes() - duration);
  const timeDifference = workingDate.getTime() - givenDate.getTime();
  return timeDifference < 0;
};

export const diffOfTwoDates = (date1, date2) => {
  const givenDate = date1 ? new Date(date1) : new Date();
  const workingDate = date2 ? new Date(date2) : new Date();
  const timeDifference = Math.abs(workingDate.getTime() - givenDate.getTime());
  return timeDifference / 1000;
};

export const makeCancelable = (fn) => {
  let hasCanceled = false;

  return {
    promise: (val) =>
      new Promise((resolve, reject) => {
        if (hasCanceled) {
          fn = null;
        } else {
          fn(val);
          resolve(val);
        }
      }),
    cancel() {
      hasCanceled = true;
    },
  };
};

export const wordCut = (word, length, pad) => {
  if (typeof word !== "string") return word;
  if (word.length <= length) return String(word);
  return word.slice(0, length) + `${pad ? pad : "..."}`;
};

export const properCase = (str) => {
  if (str && typeof str === "string" && str.trim().length === 1) {
    return String(str).trim().toUpperCase();
  }
  if (str && typeof str === "string") {
    return str
      .trim()
      .split(" ")
      .map((w) => w[0] && w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(" ");
  }
  return str;
};

// https://github.com/feross/clipboard-copy/blob/master/index.js
async function copyClipboardApi(text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (!navigator.clipboard) {
    throw new Error("Cannot copy text");
  }
  return navigator.clipboard.writeText(text);
}

async function copyExecCommand(text) {
  // Put the text to copy into a <span>
  const span = document.createElement("span");
  span.textContent = text;

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = "pre";
  span.style.webkitUserSelect = "auto";
  span.style.userSelect = "all";

  // Add the <span> to the page
  document.body.appendChild(span);

  // Make a selection object representing the range of text selected by the user
  const selection = window.getSelection();
  const range = window.document.createRange();
  selection.removeAllRanges();
  range.selectNode(span);
  selection.addRange(range);

  // Copy text to the clipboard
  let success = false;
  try {
    success = window.document.execCommand("copy");
  } finally {
    // Cleanup
    selection.removeAllRanges();
    window.document.body.removeChild(span);
  }

  if (!success) throw new Error("Cannot copy text");
}

export async function copyToClipboard(text) {
  try {
    await copyClipboardApi(text);
  } catch (err) {
    // ...Otherwise, use document.execCommand() fallback
    try {
      await copyExecCommand(text);
    } catch (err2) {
      throw err2 || err || new Error("Cannot copy text");
    }
  }
}

export function toLocaleString(input) {
  if (input) {
    return Number(input).toLocaleString();
  }

  return 0;
}

export const toPrecision = (number, precision) => {
  const num = Number(number);
  return Number(num.toFixed(precision));
};

export const unique = (arr = [], key) => {
  if (!Array.isArray(arr) || !key) return [];
  const uniques = [
    // @ts-ignore
    ...new Map(arr.map((o) => [o[key], o])).values(),
  ];
  return uniques;
};

// Public base64 to Uint
export function urlBase64ToUint8Array(base64Stringy) {
  var base64String = String(base64Stringy);
  var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function getDevice() {
  var agent = {
    browser: {
      name: null,
      version: null,
      v: null,
      userAgent: null,
      app: null,
      os: null,
    },
    mobile: false,
    pointlock: false,
  };
  try {
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = "" + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;
    agent.pointlock =
      "pointerLockElement" in document ||
      "mozPointerLockElement" in document ||
      "webkitPointerLockElement" in document;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
      browserName = "Opera";
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf("Version")) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
      browserName = "Microsoft Internet Explorer";
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
      browserName = "Chrome";
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
      browserName = "Safari";
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("Version")) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
      browserName = "Firefox";
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(" ") + 1) <
      (verOffset = nAgt.lastIndexOf("/"))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) !== -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) !== -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt("" + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = "" + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    agent.browser.name = browserName;
    agent.browser.version = fullVersion;
    agent.browser.v = majorVersion;
    agent.browser.app = navigator.appName;
    agent.browser.userAgent = navigator.userAgent;
    var OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";

    agent.browser.os = OSName;
    agent.mobile =
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1;
  } catch (err) {}
  return agent;
}

export function getUserLocation() {
  return new Promise((resolve) => {
    fetch("https://extreme-ip-lookup.com/json/", {
      method: "get",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => resolve(res))
      .catch((err) => {
        console.log("[@getUserLocation]: ", err);
        resolve({});
      });
  });
}

export const maybePluralize = (count, noun, suffix = "s") =>
  `${noun}${count !== 1 ? suffix : ""}`;

export const firstLetterCap = (str) => {
  if (str && typeof str === "string" && str.trim().length === 1) {
    return String(str).trim().toUpperCase();
  }
  if (str && typeof str === "string") {
    return [str.trim()]
      .map((w) => w[0] && w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(" ");
  }
  if (str && typeof str === "object" && str.length > 0) {
    return str.map((st) =>
      [String(st).trim()]
        .map((w) => w[0] && w[0].toUpperCase() + w.substr(1).toLowerCase())
        .join(" ")
    );
  }
  return str;
};
